import React from 'react';

import AppStore from './storeIcons/AppStore';
import GooglePlay from './storeIcons/GooglePlay';
import { StyledDivider } from './styles';
import {
  Footer as StyledFooter,
  FooterContainer,
  StoresLinks,
  TextInnerFooter
} from './styles';

interface StoreProps extends React.HTMLAttributes<HTMLElement> {
  icon?: React.FC<React.SVGAttributes<SVGElement>>;
  link?: string;
  onClick?: () => void;
}

interface FooterProps extends React.HTMLAttributes<HTMLElement> {
  variant?: 'light' | 'dark';
  position?: 'fixed' | 'absolute' | 'static';
  title?: string;
  stores?: {
    appStore?: StoreProps;
    googlePlay?: StoreProps;
  };
}

const defaultProps: FooterProps = {
  title: 'Descargá la app desde',
  stores: {
    appStore: {
      link: 'https://apps.apple.com/ar/app/ual%C3%A1/id1279808159',
      icon: AppStore
    },
    googlePlay: {
      link: 'https://play.google.com/store/apps/details?id=ar.com.bancar.uala',
      icon: GooglePlay
    }
  }
};

const Footer: React.FC<FooterProps> = ({
  title = '',
  stores = {},
  ...props
}) => {
  const footerTitle = title ? title : defaultProps.title;
  const { googlePlay, appStore } = {
    ...defaultProps.stores,
    ...stores
  };

  const AppStoreIcon = appStore?.icon || AppStore;
  const appStoreIcon = (
    <AppStoreIcon
      onClick={appStore?.onClick}
      aria-label="App Store"
      data-testid="app-store-icon"
    />
  );

  const GooglePlayIcon = googlePlay?.icon || GooglePlay;
  const googlePlayIcon = (
    <GooglePlayIcon
      onClick={googlePlay?.onClick}
      aria-label="Google Play"
      data-testid="google-play-icon"
    />
  );

  return (
    <StyledFooter {...props}>
      <FooterContainer>
        <TextInnerFooter id="footer-title" data-testid="footer-title">
          {footerTitle}
        </TextInnerFooter>
        <StoresLinks
          href={appStore?.link}
          target="_blank"
          rel="noreferrer"
          id="footer-appstore"
          data-testid="footer-appstore"
        >
          {appStoreIcon}
        </StoresLinks>
        <StyledDivider />
        <StoresLinks
          href={googlePlay?.link}
          target="_blank"
          rel="noreferrer"
          id="footer-playstore"
          data-testid="footer-playstore"
        >
          {googlePlayIcon}
        </StoresLinks>
      </FooterContainer>
    </StyledFooter>
  );
};

export default Footer;
